import {TestExplorer as OldTestExplorer} from '@esgi/main/old';

export default function () {
	return <OldTestExplorer excludeLayout/>;
}